module.exports = __webpack_public_path__ + "img/parter-work14.f667e2e0.png";